import React, { Component } from "react";
import config from "@config";
export default class SignUpCommercial extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: this.props.email || "",
      name: "",
      password1: "",
      password2: "",
      showPassword: false,
      typePassword: true,
      errorPassword: false,
      errorStoreLocation: false,
      commercial_location_notes: "",
      brand_id: null,
    };
  }

  componentDidMount() {
    this.retrieveBrandId();
  }

  retrieveBrandId = () => {
    const url = `${config.backendServer}brands/`;

    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          const error = await response.json();
          throw error;
        }
      })
      .then((data) => {
        // Process brand data here
        const brandList =
          data.filter((brand) => brand.country === config.country) || [];
        this.setState({ brandList });
      })
      .catch((error) => {
        console.error("Error fetching brand data:", error);
      });
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    let payload = {
      brand_id: this.state.brandList?.map((brand) => brand.id) || null,
      name: this.state.name,
      email: this.state.email ? this.state.email.toLowerCase() : "",
      password: this.state.password1,
      commercial_location_notes: this.state.commercial_location_notes,
    };

    if (this.state.password1 !== this.state.password2) {
      this.setState({
        loading: false,
        errorPassword: true,
        errorBrand: false,
      });
    } else if (
      !payload.commercial_location_notes &&
      payload.commercial_location_notes === ""
    ) {
      this.setState({
        loading: false,
        errorPassword: false,
        errorBrand: false,
      });
    } else if (this.state.brandList?.length === 0) {
      this.setState({
        loading: false,
        errorPassword: false,
        errorBrand: true,
      });
    } else {
      this.props.onSubmit({ ...payload });
    }
  };

  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  render() {
    return (
      <div className="card">
        <h4 className={"card-header"}>Registration</h4>
        <form onSubmit={this.handleSubmit}>
          <div className="card-body">
            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Full name<span>:</span>
              </label>
              <input
                type="text"
                id="name"
                required={true}
                className="form-control"
                onChange={this.handleChange}
              />
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Email <span>:</span>
              </label>
              <input
                type="email"
                id="email"
                defaultValue={this.state.email}
                required={true}
                className="form-control"
                onChange={this.handleChange}
              />
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Password{" "}
                <i
                  className={
                    this.state.typePassword
                      ? "password-show fa fa-eye"
                      : "password-show fa fa-eye-slash"
                  }
                  aria-hidden="true"
                  onClick={() =>
                    this.setState({
                      typePassword: !this.state.typePassword,
                    })
                  }
                ></i>
                <span>:</span>
              </label>
              <input
                type={this.state.typePassword ? "password" : "text"}
                id="password1"
                required={true}
                className="form-control"
                onChange={this.handleChange}
              />
              {this.state.errorPassword ? (
                <span className="error-text">Password did not match</span>
              ) : null}
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Confirm Password <span>:</span>
              </label>
              <input
                type={this.state.typePassword ? "password" : "text"}
                id="password2"
                required={true}
                className="form-control"
                onChange={this.handleChange}
              />
              {this.state.errorPassword ? (
                <span className="error-text">Password did not match</span>
              ) : null}
            </div>

            <div className={"single-warranty-details-item"}>
              <label className={"single-warranty-details-label required"}>
                Store Location<span>:</span>
              </label>
              <input
                id="commercial_location_notes"
                required={true}
                placeholder="Store name - Store Location"
                className="form-control"
                onChange={this.handleChange}
              />
              {this.state.errorStoreLocation ? (
                <span className="error-text">Store location required</span>
              ) : null}
              {this.state.errorBrand ? (
                <span className="error-text">No brand available for registration</span>
              ) : null}
            </div>
          </div>

          <div className="card-footer">
            <div className="d-flex flex-row mb-3 gap-2">
              <div>
                <button type="submit" className={"btn btn-outline-primary"}>
                  Register
                </button>
              </div>
              <div>
                <button
                  className={"btn btn-outline-secondary"}
                  onClick={this.props.onCloseModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
